<template>
  <v-main role="presentation" class="white_background">
    <v-container text-xs-center>
      <v-row class="widthForContent">
        <v-col text-xs-center mt-4 mb-4>
          <v-row>
            <v-col cols="12" class="text-center font-size--20 font-weight-bold">
              <div>
                {{ $t('L_enable_face_id_or_fingerprint_id_later') }}
              </div>
            </v-col>
            <v-col cols="12" mt-4 pt-4>
              <v-img
                height="257"
                width="236"
                src="@/assets/ErrorBiometrics.svg"
                class="mx-auto"
                alt="Mobile phone biometrics enable later via account settings"
              />
            </v-col>
          </v-row>
          <div
            class="mx-auto mb-12 mt-4"
            :class="$vuetify.display.xs ? 'overall-div-card-smaller' : 'overall-div-card-larger'"
          >
            <v-row>
              <v-col
                cols="12"
                font-weight-regular
                font-size--20
                class="text-center regular_body_text"
              >
                <span>{{ $t('L_you_can_enable_faceid_or_fingerprint_id_later') }}</span>
              </v-col>
            </v-row>
          </div>
          <v-row text-xs-center class="outerlayout">
            <div class="innerLayout">
              <v-col cols="12" my-4>
                <OnexButton
                  block
                  class="btn_default bg-primary mx-4 px-4 font-size--20"
                  @click="goToNextFlow"
                >
                  {{ $t('L_ok') }}
                </OnexButton>
              </v-col>
            </div>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { LOCALES } from '@/shared/models/constants.models';
import { RouteNames } from '@/router/routeNames';
import { useGlobalStore } from '@/stores/global/global.store';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { mapStores } from 'pinia';
import { OnexButton } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'ErrorBiometrics',
  components: {
    OnexButton,
  },
  props: {
    color: {
      type: String,
      default: '#063562',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 70,
    },
    width: {
      type: Number,
      default: 7,
    },
  },
  data: () => ({
    languagesPrefs: window.appConfig.languagePreferences,
    languages: [] as LOCALES[],
    isFaceId: false,
    isTouchId: false,
  }),
  computed: { ...mapStores(useGlobalStore, useCustomerStore) },
  methods: {
    async goToNextFlow() {
      const deeplinkroute = window.localStorage.getItem('deeplinkroute'); // ? this is a path, NOT name of a route
      let nextRoute;
      if (this.globalStore.hasTermsOfUseTask) nextRoute = RouteNames.TERMS_OF_USE;
      else if (this.globalStore.hasPolicyAckTask) nextRoute = RouteNames.POLICY_ACKNOWLEDGEMENT;
      else {
        window.localStorage.removeItem('deeplinkroute'); // remove the deeplink route
        nextRoute = deeplinkroute ?? RouteNames.DASHBOARD; // there are no post login tasks
      }
      await this.$router.push(deeplinkroute ? { path: nextRoute } : { name: nextRoute });
    },
    updateLocale(language: string) {
      this.globalStore.updateLocale(language as LOCALES);
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.background {
  min-height: 100%;
  background-image: linear-gradient(to top, #607c97, #063562);
}

.white_background {
  min-height: 100%;
  background-color: white;
}

.css_locale {
  background-color: white;
}

.css_app_update {
  font-size: 20px;
  font-weight: bold;
}

.regular_body_text {
  font-size: 20px;
}

.language-icon {
  color: white !important;
}

.container {
  max-width: 960px !important;
}

.widthForContent {
  max-width: 600px !important;
  margin: auto;
}

.btn_default {
  min-width: 250px;
  max-width: 350px;
  margin: auto;
  height: 48px;
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
}

.outerlayout {
  padding-bottom: 50px;
}

.innerLayout {
  margin: auto !important;
  padding-bottom: 300px;
}

.btn_white {
  background-color: white !important;
}

.centerProgress {
  left: calc(50% + -38px);
  top: 50vh;
  position: absolute;
}
</style>
